<template>
  <div class="teaser-big-image-slider-element-fi">
    <sub-rendering-provider
      :fields="fields"
      :data-source
    >
      <teaser-big-image-element-fi
        :fields="fields"
        :pause-video="slideChanged"
        is-slider-element
      />
    </sub-rendering-provider>
  </div>
</template>

<script setup lang="ts">
import type { ComponentRendering } from '@sitecore-jss/sitecore-jss-vue';
import { inject } from 'vue';

import SubRenderingProvider from '@/components/atoms/multi-data-source-provider-fi/SubRenderingProvider.vue';
import TeaserBigImageElementFi from '@/components/teaser/teaser-big-image-element-fi/TeaserBigImageElementFi.vue';

defineOptions({ name: 'TeaserBigImageSliderElementFi' });

interface Props {
  fields?: Record<string, unknown>;
  slideChanged?: boolean;
}

withDefaults(defineProps<Props>(), {
  fields: () => ({}),
  slideChanged: false,
});

const rendering = inject<ComponentRendering>('rendering');
const dataSource = IS_SHOWROOM ? 'showroom' : rendering?.dataSource || '';
</script>
